module.exports = __webpack_public_path__ + "img/imgZXGH(27).bbe0f899.png";